import { useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { getCurrentCartStoreAddress, isCartEmpty as hasNoItems } from '@/logic/cart/reducer'
import { useData } from '@/logic/data'
import type { RootState } from '@/redux/interfaces'
import type { ICart } from '@/types/Cart'
import type { IUseCartOptions } from './interfaces'

const mapState = (state: RootState) => ({
  isCartEmpty: hasNoItems(state),
  storeAddress: getCurrentCartStoreAddress(state),
})

export const useCartParams = () => useParams<{ cartId: string }>()

const defaultOptions: IUseCartOptions = {
  shouldLoadForcibly: true,
}

export const useCart = ({ shouldLoadForcibly = true }: IUseCartOptions = defaultOptions) => ({
  ...useData<ICart>('cart', { shouldLoadForcibly, params: useCartParams() }),
  ...useSelector(mapState),
})
